import { AfterContentInit, Component, ContentChildren, EventEmitter, forwardRef, HostListener, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { OptionComponent } from '../option/option.component';
import { Dropdown } from 'primeng/dropdown';

@Component({
  selector: 'townip-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DropdownComponent),
    multi: true,
  }]
})
export class DropdownComponent implements OnInit, AfterContentInit, OnChanges, ControlValueAccessor {

  @ContentChildren(OptionComponent)
  private availableOptions: QueryList<OptionComponent>;

  @ViewChild(Dropdown, { static: true })
  public dropdown: Dropdown;

  @Input()
  public filter = true;

  /**
   * Set to true if you want the dropdown to follow the width if its container
   */
  @Input()
  public fluid = false;

  @Input()
  public placeholder = 'Select';

  @Input()
  public filterPlaceHolder = '';

  @Input()
  public disabled = false;

  @Input()
  public size = ''; // sm lg or blank(Default)

  @Input()
  public appendTo: string;

  @Input()
  public dataKey: string;

  @Input()
  public minWidthNone = false;

  @Input()
  public virtualScroll = false;

  @Input()
  public readonly = false;

  @Input()
  public autoDisplayFirst = false;

  @Input()
  public forceMenuBottomPosition = false;

  @Output()
  public selected = new EventEmitter<any>();

  public onChange: any;

  public onTouched: any;

  public selectItems: SelectItem[] = [];

  public currentValue: any;

  public baseStyle: string;

  public virtualScrollSize = 30;

  constructor() { }

  public ngOnInit(): void {
    this.parseStyle();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.parseStyle();
    this.parseSize();
  }

  public ngAfterContentInit(): void {
    this.parseOptions();
    this.availableOptions
      .changes
      .subscribe(() => {
        this.parseOptions();
      });
  }

  public writeValue(value: any): void {
    this.currentValue = value;
    this.dropdown.filterValue = '';
  }

  public registerOnChange(func: any): void {
    this.onChange = func;
  }

  public registerOnTouched(func: any): void {
    this.onTouched = func;
  }

  public handleSelection(): void {
    if (this.onChange) {
      this.onChange(this.currentValue);
    }

    if (this.onTouched) {
      this.onTouched(true);
    }

    this.selected.emit(this.currentValue);
  }

  @HostListener('click')
  private dropdownClicked(): void {
    if (this.onTouched) {
      this.onTouched(true);
    }
  }

  private parseOptions(): void {
    this.selectItems = this.availableOptions.map(opt => {
      return { label: opt.label, value: opt.value };
    });
  }

  private parseStyle(): void {
    this.baseStyle = 'app-dropdown';

    if (this.forceMenuBottomPosition) {
      this.baseStyle += ' source-language-options';
    }

    if (this.fluid) {
      this.baseStyle += ' full-width';
    }

    if (this.size && this.size !== '') {
      this.baseStyle += ` ${this.size}`;
    }

    if (this.minWidthNone) {
      this.baseStyle += ' min-width-none';
    }

    if (this.readonly) {
      this.baseStyle += ' readonly';
    }
  }

  private parseSize(): void {
    // NOTE: This is where would be the adjustments in case different sizes become a problem
    // switch(this.size) {
    //   case 'lg':
    //     this.virtualScrollSize = 35;
    //     break;
    //   default:
    //     this.virtualScrollSize = 30;
    // }
  }
}
